export default "__VITE_ASSET__CnTyjxnS__"